import { render } from "./ContactModule.vue?vue&type=template&id=00800dae&scoped=true"
import script from "./ContactModule.vue?vue&type=script&lang=js"
export * from "./ContactModule.vue?vue&type=script&lang=js"

import "./ContactModule.vue?vue&type=style&index=0&id=00800dae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00800dae"]])

export default __exports__